import api from "@/services/api.ts";
import {FAQ} from "@/types/FAQ.ts";

const URL = '/faq';

// Create FAQ
export const createFAQ = async (faq: FAQ): Promise<FAQ> => {
    try{
        const response = await api.post(URL, faq);
        return response.data;
    } catch (error) {
        throw new Error('Failed to create FAQ');
    }
}

export const getFAQById = async (id: number): Promise<FAQ | null> => {
    try {
        const response = await api.get(`${URL}/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return null;
        }
        throw error;
    }
};

// Update FAQ
export const updateFAQ = async (id: number, faq: FAQ): Promise<FAQ> => {
    try {
        const response = await api.put(`${URL}/${id}`, faq);
        return response.data;
    } catch (error) {
        throw new Error('Failed to update FAQ');
    }
}

// Get All FAQs
export const getFAQs = async (): Promise<FAQ[]> => {
    const response = await api.get<FAQ[]>(URL);
    return response.data;
};

// Delete FAQ
export const deleteFAQ = async (id: number): Promise<void> => {
    try{
        await api.delete(`${URL}/${id}`);
    } catch (error) {
        throw new Error('Failed to delete FAQ');
    }
};
